module.exports = __webpack_public_path__ + "img/06.4ba04f2a.jpg";